// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EYr1UlFPP9sDXLcB {
  width: 1184px;
  max-width: 100%;
  margin: 0 auto;
  padding: 40px 0 96px;
  box-sizing: border-box;
}

.V_Wno6ydTbwpbXOk {
  font-family: Roboto, sans-serif;
  font-weight: 600;
  font-size: 32px;
  line-height: 120%;
  letter-spacing: 0;
  text-transform: capitalize;
  color: rgba(0, 0, 0, 1);
  margin: 0 0 32px;
}

.sCrMiW51OhAx8Y1R {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.yOc2MEGEYEm8_A0p {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(217, 217, 217, 1);
  flex-shrink: 0;
  margin-right: 16px;
}

.DNEbukV_iwJ1DSOM {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.GxVGRJh9wxsCuKpz {
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0;
  text-transform: capitalize;
  color: rgba(0, 0, 0, 1);
}

.NV5Kh2_zAA6XvfN7 {
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0;
  color: rgba(0, 0, 0, 0.7);
}

.jpbeAjpUZccfV2ty {
  background: rgba(249, 249, 249, 1);
  border-radius: 16px;
  padding: 24px;
  box-sizing: border-box;
}

.D4iAawLub1IWtDWV {
  height: 16px;
}

.frNjHFqqK_cWgq73 {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.N2Vc8XCMFKUMOVFM {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  display: block;
}

.roJ3EtBHlYWP1cti {
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0;
  color: rgba(32, 51, 108, 1);
}

.jRwv5YbSJcyhdwx1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.Jj94a6jWsEYyFZcm {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.KmuUP5I40WcouywT {
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0;
  color: rgba(0, 0, 0, 1);
}

.fRUx3PaP8kHdOVYC {
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0;
  color: rgba(0, 0, 0, 0.7);
  word-break: break-word;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.ArVTyVxjbAcnC7Cl {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: background-color 0.15s;
}

.ArVTyVxjbAcnC7Cl:hover {
  background-color: rgba(32, 51, 108, 0.08);
}

.ArVTyVxjbAcnC7Cl:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.gcsQOzfz2uMlGK7y {
  border: 1.79px solid rgba(77, 135, 190, 1);
  color: rgba(77, 135, 190, 1);
}

.gcsQOzfz2uMlGK7y:hover {
  background-color: rgba(77, 135, 190, 0.08);
}

.zPaTccDKuEAZxl9d {
  width: 36px;
  height: 36px;
  display: block;
}

.bZr7iKvr4cuW_t81 {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.oklUKnMcIBsTWouE {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.QtqWojOJm84LC21u {
  padding: 8px 0;
}

.pJVpktYo9gg71H9C {
  display: flex;
  align-items: center;
  gap: 12px;
}

.OyZ7AbGZglMtpbPX {
  flex: 1;
  height: 40px;
  padding: 0 12px;
  border: 1.5px solid #d9d9d9;
  border-radius: 8px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  outline: none;
  background: #fff;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.OyZ7AbGZglMtpbPX:focus {
  border-color: #20336c;
  box-shadow: 0 0 0 3px rgba(32, 51, 108, 0.08);
}

.CVup2K5PPLUOei0G {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.CVup2K5PPLUOei0G .p-button.p-button-icon-only {
  width: 36px;
  height: 36px;
}

.ZcDvlitiDMEmE2Ue {
  font-size: 13px;
  color: #c62828;
  margin-top: 4px;
}

@media screen and (max-width: 1240px) {
  .EYr1UlFPP9sDXLcB {
    padding-left: 28px;
    padding-right: 28px;
  }
}

@media screen and (max-width: 1024px) {
  .EYr1UlFPP9sDXLcB {
    padding: 32px 24px 80px;
  }
}

@media screen and (max-width: 768px) {
  .EYr1UlFPP9sDXLcB {
    padding: 24px 16px 80px;
  }

  .V_Wno6ydTbwpbXOk {
    font-size: 24px;
    margin-bottom: 24px;
  }

  .GxVGRJh9wxsCuKpz {
    font-size: 20px;
  }

  .NV5Kh2_zAA6XvfN7 {
    font-size: 14px;
  }

  .yOc2MEGEYEm8_A0p {
    width: 56px;
    height: 56px;
  }

  .jpbeAjpUZccfV2ty {
    padding: 16px;
  }

  .frNjHFqqK_cWgq73 {
    margin-bottom: 16px;
  }

  .N2Vc8XCMFKUMOVFM {
    width: 20px;
    height: 20px;
  }

  .roJ3EtBHlYWP1cti {
    font-size: 18px;
  }

  .KmuUP5I40WcouywT {
    font-size: 14px;
  }

  .fRUx3PaP8kHdOVYC {
    font-size: 16px;
  }

  .oklUKnMcIBsTWouE {
    gap: 16px;
  }

  .QtqWojOJm84LC21u {
    padding: 4px 0;
  }

  .ArVTyVxjbAcnC7Cl {
    width: 36px;
    height: 36px;
  }

  .zPaTccDKuEAZxl9d {
    width: 28px;
    height: 28px;
  }

  .pJVpktYo9gg71H9C {
    gap: 8px;
  }
}

@media screen and (max-width: 480px) {
  .EYr1UlFPP9sDXLcB {
    padding: 32px 24px 104px;
  }

  .V_Wno6ydTbwpbXOk {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  .sCrMiW51OhAx8Y1R {
    margin-bottom: 24px;
  }

  .yOc2MEGEYEm8_A0p {
    width: 56px;
    height: 56px;
    margin-right: 16px;
  }

  .DNEbukV_iwJ1DSOM {
    gap: 8px;
  }

  .GxVGRJh9wxsCuKpz {
    font-size: 18px;
    font-weight: 600;
  }

  .NV5Kh2_zAA6XvfN7 {
    font-size: 12px;
    font-weight: 400;
  }

  .D4iAawLub1IWtDWV {
    height: 14px;
  }

  .jpbeAjpUZccfV2ty {
    padding: 24px;
    border-radius: 16px;
  }

  .frNjHFqqK_cWgq73 {
    margin-bottom: 24px;
  }

  .N2Vc8XCMFKUMOVFM {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  .roJ3EtBHlYWP1cti {
    font-size: 18px;
    font-weight: 500;
  }

  .Jj94a6jWsEYyFZcm {
    gap: 16px;
  }

  .KmuUP5I40WcouywT {
    font-size: 12px;
    font-weight: 400;
  }

  .fRUx3PaP8kHdOVYC {
    font-size: 14px;
  }

  .oklUKnMcIBsTWouE {
    gap: 24px;
  }

  .QtqWojOJm84LC21u {
    padding: 0;
  }

  .ArVTyVxjbAcnC7Cl {
    width: 36px;
    height: 36px;
  }

  .zPaTccDKuEAZxl9d {
    width: 20px;
    height: 20px;
  }

  .OyZ7AbGZglMtpbPX {
    height: 36px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/Account/Account.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".pageWrapper {\r\n  width: 1184px;\r\n  max-width: 100%;\r\n  margin: 0 auto;\r\n  padding: 40px 0 96px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.title {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 600;\r\n  font-size: 32px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  text-transform: capitalize;\r\n  color: rgba(0, 0, 0, 1);\r\n  margin: 0 0 32px;\r\n}\r\n\r\n.userRow {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.avatar {\r\n  width: 72px;\r\n  height: 72px;\r\n  border-radius: 50%;\r\n  background: rgba(217, 217, 217, 1);\r\n  flex-shrink: 0;\r\n  margin-right: 16px;\r\n}\r\n\r\n.userInfo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.userName {\r\n  font-family: Montserrat, sans-serif;\r\n  font-weight: 600;\r\n  font-size: 24px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  text-transform: capitalize;\r\n  color: rgba(0, 0, 0, 1);\r\n}\r\n\r\n.userRole {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  color: rgba(0, 0, 0, 0.7);\r\n}\r\n\r\n.card {\r\n  background: rgba(249, 249, 249, 1);\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.cardSpacer {\r\n  height: 16px;\r\n}\r\n\r\n.cardHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.cardHeaderIcon {\r\n  width: 24px;\r\n  height: 24px;\r\n  margin-right: 8px;\r\n  display: block;\r\n}\r\n\r\n.cardHeaderTitle {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 500;\r\n  font-size: 20px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  color: rgba(32, 51, 108, 1);\r\n}\r\n\r\n.field {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n}\r\n\r\n.fieldContent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.fieldLabel {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  color: rgba(0, 0, 0, 1);\r\n}\r\n\r\n.fieldValue {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  color: rgba(0, 0, 0, 0.7);\r\n  word-break: break-word;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.editButton {\r\n  width: 36px;\r\n  height: 36px;\r\n  border: none;\r\n  background: transparent;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 8px;\r\n  transition: background-color 0.15s;\r\n}\r\n\r\n.editButton:hover {\r\n  background-color: rgba(32, 51, 108, 0.08);\r\n}\r\n\r\n.editButton:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n.telegramButton {\r\n  border: 1.79px solid rgba(77, 135, 190, 1);\r\n  color: rgba(77, 135, 190, 1);\r\n}\r\n\r\n.telegramButton:hover {\r\n  background-color: rgba(77, 135, 190, 0.08);\r\n}\r\n\r\n.editIcon {\r\n  width: 36px;\r\n  height: 36px;\r\n  display: block;\r\n}\r\n\r\n.nameFieldsList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n.channelsList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n.channelItem {\r\n  padding: 8px 0;\r\n}\r\n\r\n.editInputRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.editInput {\r\n  flex: 1;\r\n  height: 40px;\r\n  padding: 0 12px;\r\n  border: 1.5px solid #d9d9d9;\r\n  border-radius: 8px;\r\n  font-family: Roboto, sans-serif;\r\n  font-size: 16px;\r\n  outline: none;\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n  transition: border-color 0.15s;\r\n}\r\n\r\n.editInput:focus {\r\n  border-color: #20336c;\r\n  box-shadow: 0 0 0 3px rgba(32, 51, 108, 0.08);\r\n}\r\n\r\n.editActions {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.editActions :global(.p-button.p-button-icon-only) {\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n\r\n.errorText {\r\n  font-size: 13px;\r\n  color: #c62828;\r\n  margin-top: 4px;\r\n}\r\n\r\n@media screen and (max-width: 1240px) {\r\n  .pageWrapper {\r\n    padding-left: 28px;\r\n    padding-right: 28px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .pageWrapper {\r\n    padding: 32px 24px 80px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .pageWrapper {\r\n    padding: 24px 16px 80px;\r\n  }\r\n\r\n  .title {\r\n    font-size: 24px;\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .userName {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .userRole {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .avatar {\r\n    width: 56px;\r\n    height: 56px;\r\n  }\r\n\r\n  .card {\r\n    padding: 16px;\r\n  }\r\n\r\n  .cardHeader {\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .cardHeaderIcon {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n\r\n  .cardHeaderTitle {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .fieldLabel {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .fieldValue {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .channelsList {\r\n    gap: 16px;\r\n  }\r\n\r\n  .channelItem {\r\n    padding: 4px 0;\r\n  }\r\n\r\n  .editButton {\r\n    width: 36px;\r\n    height: 36px;\r\n  }\r\n\r\n  .editIcon {\r\n    width: 28px;\r\n    height: 28px;\r\n  }\r\n\r\n  .editInputRow {\r\n    gap: 8px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .pageWrapper {\r\n    padding: 32px 24px 104px;\r\n  }\r\n\r\n  .title {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .userRow {\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .avatar {\r\n    width: 56px;\r\n    height: 56px;\r\n    margin-right: 16px;\r\n  }\r\n\r\n  .userInfo {\r\n    gap: 8px;\r\n  }\r\n\r\n  .userName {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .userRole {\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .cardSpacer {\r\n    height: 14px;\r\n  }\r\n\r\n  .card {\r\n    padding: 24px;\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .cardHeader {\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .cardHeaderIcon {\r\n    width: 20px;\r\n    height: 20px;\r\n    margin-right: 8px;\r\n  }\r\n\r\n  .cardHeaderTitle {\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .fieldContent {\r\n    gap: 16px;\r\n  }\r\n\r\n  .fieldLabel {\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .fieldValue {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .channelsList {\r\n    gap: 24px;\r\n  }\r\n\r\n  .channelItem {\r\n    padding: 0;\r\n  }\r\n\r\n  .editButton {\r\n    width: 36px;\r\n    height: 36px;\r\n  }\r\n\r\n  .editIcon {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n\r\n  .editInput {\r\n    height: 36px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `EYr1UlFPP9sDXLcB`;
export var title = `V_Wno6ydTbwpbXOk`;
export var userRow = `sCrMiW51OhAx8Y1R`;
export var avatar = `yOc2MEGEYEm8_A0p`;
export var userInfo = `DNEbukV_iwJ1DSOM`;
export var userName = `GxVGRJh9wxsCuKpz`;
export var userRole = `NV5Kh2_zAA6XvfN7`;
export var card = `jpbeAjpUZccfV2ty`;
export var cardSpacer = `D4iAawLub1IWtDWV`;
export var cardHeader = `frNjHFqqK_cWgq73`;
export var cardHeaderIcon = `N2Vc8XCMFKUMOVFM`;
export var cardHeaderTitle = `roJ3EtBHlYWP1cti`;
export var field = `jRwv5YbSJcyhdwx1`;
export var fieldContent = `Jj94a6jWsEYyFZcm`;
export var fieldLabel = `KmuUP5I40WcouywT`;
export var fieldValue = `fRUx3PaP8kHdOVYC`;
export var editButton = `ArVTyVxjbAcnC7Cl`;
export var telegramButton = `gcsQOzfz2uMlGK7y`;
export var editIcon = `zPaTccDKuEAZxl9d`;
export var nameFieldsList = `bZr7iKvr4cuW_t81`;
export var channelsList = `oklUKnMcIBsTWouE`;
export var channelItem = `QtqWojOJm84LC21u`;
export var editInputRow = `pJVpktYo9gg71H9C`;
export var editInput = `OyZ7AbGZglMtpbPX`;
export var editActions = `CVup2K5PPLUOei0G`;
export var errorText = `ZcDvlitiDMEmE2Ue`;
export default ___CSS_LOADER_EXPORT___;
